import { SettingsService } from '../sys/settings.service';
import { SyntacticSugarService } from '../sys/syntactic-sugar.service';
import { Injectable } from '@angular/core';

@Injectable()
export class WindowService {
    
    //The name of the new window when it is opened
    readonly windowName: string = "_blank";
    //A string that the original window will listen for to indicate the new window is loaded
    readonly readyIndicator: string = "ready";
    
    constructor(private settingsService: SettingsService,
        private syntacticSugarService: SyntacticSugarService) {
    }
    
    /*
     * Open a new window and send data to it. "url" is the url for the new window.
     * "data" is any data you want sent to the new window. the window name will be
     * "_blank".
     */
    public postMessage(url: string, data: any) : void {
        let newWindow = this.openNewWindow(url);
        this.addMessageEventListener(this.post.bind(this, data, newWindow));
    }
    
    /*
     * Add an event listener to the current window to listen for 'message' events. These 
     * are the events that are fired when "postMessage" is called.
     */
    public addMessageEventListener(listener : EventListenerOrEventListenerObject) : void {
        window.addEventListener("message", listener, false);
    }
    
    /*
     * Remove the message event listener
     */
    public removeMessageEventListener(listener : EventListenerOrEventListenerObject) : void {
        window.removeEventListener("message", listener);
    }
    
    /*
     * The original window needs to know when the new window is done loading and ready to
     * receive data. "onload" doesn't work since the component that sets up the listener
     * in the new window isn't finished yet. So we need the new window to tell us it is ready.
     * "win" should be window.opener and called from the new window.
     */
    public indicateNewWindowIsReady(win: Window) {
        win.postMessage(this.readyIndicator, this.getHostUrl());
    }
    
    /*
     * Open a new external link window "url" is the url for the new window.
     * The window name will be "_blank".
     */
    public openExternalWindow(url: string) : void {
        let newWindow = this.openNewWindow(url);
    };
      
    /*
     * Open a new window at the given url with the default window name and return a 
     * reference to the new window.
     */
    private openNewWindow(url: string) : Window {
        let newWindow = window.open(url, this.windowName);
        return newWindow;
    }
    
    /*
     * Post data to the new window. "data" is the data you want posted, "newWindow" is the
     * window to post it to, "event" is a MessageEvent because this method is bound to the
     * "message" event.
     */
    private post(data: any, newWindow: Window, event : MessageEvent) : void {
        //Not sure this provides any value.
        if(event.data != this.readyIndicator) {
            return;
        }
        //postMessage should serialize the data for us, but it seems to have trouble with the FafsaForm object,
        //possibly because that object has methods on it. cloning it resolves the issue.
        let postData = this.syntacticSugarService.clone(data);
        newWindow.postMessage(postData, this.getHostUrl());
        //we only expect to receive one message, so remove the binding
        this.removeMessageEventListener(this.post.bind(this));
    }
    
    /*
     * The URL that the windows will accept messages from.  If the scheme, hostname, or port of this string
     * do not match that of the sender's document the event will not be dispatched.
     */
    private getHostUrl() : string {
        return this.settingsService.getNgHostname();
    }
}